<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              size="mini"
              clearable
              v-model="search.name"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchRoleList"
          ></el-input>
          <el-select size="mini" v-model="search.type" clearable placeholder="请选择">
            <el-option label="自定义" value="1"></el-option>
            <el-option label="默认" value="0"></el-option>
          </el-select>
          <el-button size="mini" type="primary" @click="SearchRoleList"
          >查询
          </el-button
          >
          <el-button
              size="mini"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width:1000px"
              row-key="roleId"
              v-loading="loading"
          >
            <el-table-column fixed label="序号" prop="roleId" type="index" width="80">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="板块名称" min-width="150">
            </el-table-column>
            <el-table-column prop="image" label="板块类型" min-width="180">
              <template slot-scope="score">
                <el-tag size="mini" type="primary" v-if="score.row.type == 1">自定义</el-tag>
                <el-tag size="mini" type="success" v-else>默认</el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('edit', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑板块"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="450px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-form-item
              label="板块名称："
              prop="name"
          >
            <el-input
                clearable
                placeholder="请填写板块名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>

export default {
  data() {
    return {
      search: {},
      loading: false,
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写板块名称", trigger: "blur"}],
      }, //表单验证提示
      tableData: [], //二级--角色列表，
      dialogVisible: false
    };
  },
  created() {
    this.getLanguageList();
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    SearchRoleList() {
      this.getLanguageList()
    },
    async getLanguageList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/region/list`,this.search,
      );
      this.loading = false;
      this.tableData = res.data;
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "add") {
        this.params = {};
      } else if (type == "edit") {
        this.params = JSON.parse(JSON.stringify(row));
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post("/region/save", this.params, {
            headers: {
              isLoading: true,
            },
          });
          if (resData.result != 200) return;
          this.getLanguageList();
          this.dialogVisible = false; //弹窗隐藏
          this.$message.success("添加成功!");
        });
      });
    },
    //删除
    async del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$post(
            `/region/delete/${row.id}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getLanguageList();
        this.$message.success("删除成功!");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  .fa-line {
    display: block;
    border-right: 1px solid #ccc;
  }

  &Left {
    padding-right: 15px;
    width: auto;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    padding-left: 15px;
    border-left: 1px solid #ccc;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
